import { QueryObserverBaseResult, useQuery } from "react-query";
import api from "../../client";
import { queryKeys } from "../../query";
import { PeopleListResponseData } from "../../types/people";
import { QueryParams } from "../../types/base";

export interface ExtendedQueryParams extends QueryParams {
  approved?: boolean | null;
  search?: string;
  sortField?: string;
  sortOrder?: string;
}
export const getData = async (params?: ExtendedQueryParams) => {
  const { data } = await api.get<PeopleListResponseData>(`/profiles`, {
    params,
  });

  return data;
};

export const usePeopleList = (
  params?: ExtendedQueryParams,
): QueryObserverBaseResult<PeopleListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.peopleList(params),
    () => getData(params),
    { keepPreviousData: true },
  );
  return { data, ...props };
};
